/* Keep Kaching's variant controls and cart/discount handling intact. */
(() => {
  if (window.haimaBundleLayout) return;
  window.haimaBundleLayout = true;

  const readJSON = (selector) => {
    try { return JSON.parse(document.querySelector(selector)?.textContent || 'null'); }
    catch { return null; }
  };
  const setText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  const initializedComponents = new WeakSet();

  function defaultSizeVariants(settings, product) {
    const sizeIndex = product.options.findIndex((option) => option.name.toLowerCase() === 'size');
    if (sizeIndex < 0 || new URLSearchParams(location.search).has('variant')) return settings.defaultVariantsV2;
    const defaults = settings.defaultVariantsV2 || [];
    const productId = String(product.id);
    const entries = settings.dealBars.filter((deal) =>
      deal.dealBarType === 'quantity-break' || deal.dealBarType === 'bxgy'
    ).map((deal) => {
      const existing = defaults.find((item) => String(item.productGID).split('/').pop() === productId &&
        item.dealBarId === deal.id);
      const quantity = deal.dealBarType === 'bxgy' ? deal.buyQuantity + deal.getQuantity : deal.quantity;
      const variantGIDs = Array.from({ length: quantity }, (_, index) => {
        const previousId = String(existing?.variantGIDs[index] || '').split('/').pop();
        const previous = product.variants.find((variant) => String(variant.id) === previousId) || product.variants[0];
        const original = product.variants.find((variant) => variant.availableForSale &&
          variant.options.every((value, i) => value === (i === sizeIndex ? 'Original' : previous.options[i])));
        return (original || previous).id;
      });
      return { dealBarId: deal.id, productGID: product.id, variantGIDs };
    });
    return [...defaults.filter((item) => String(item.productGID).split('/').pop() !== productId), ...entries];
  }

  function refresh() {
    const section = document.querySelector('[data-haima-bundle-product-id]');
    if (!section) return;
    const productId = section.dataset.haimaBundleProductId;
    const product = readJSON(`.kaching-bundles-product[data-product-id="${productId}"][data-main="true"]`);
    if (!product) return;
    const settings = readJSON(`.kaching-bundles-deal-block-settings[data-product-id="${product.id}"]`);
    if (!settings) return;

    section.querySelectorAll('.kaching-bundles__block').forEach((block) => {
      if (block.dataset.dealBlockId !== settings.id) return;
      // Kaching otherwise copies the first bracelet's options to matching rows.
      // Use its component setting so selections and cart items stay independent.
      const component = block.closest('kaching-bundles-block');
      if (component?.dealBlock) {
        if (!initializedComponents.has(component)) {
          initializedComponents.add(component);
          component.dealBlock = { ...component.dealBlock, disableVariantOptionSync: true,
            defaultVariantsV2: defaultSizeVariants(component.dealBlock, product) };
        } else if (!component.dealBlock.disableVariantOptionSync) {
          component.dealBlock = { ...component.dealBlock, disableVariantOptionSync: true };
        }
      }
      block.classList.add('haima-bundle');
      block.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
        const deal = settings.dealBars.find((item) => item.id === bar.dataset.dealBarId);
        if (!deal) return;
        const isFreeGiftOffer = deal.dealBarType === 'quantity-break' && deal.quantity === 1 &&
          deal.freeGifts?.length === 1 && deal.freeGifts[0].giftType === 'product' &&
          deal.freeGifts[0].quantity === 1;
        const isBogo = isFreeGiftOffer || (deal.dealBarType === 'bxgy' && deal.buyQuantity === 1 &&
          deal.getQuantity === 1 && deal.getDiscountType === 'percentage' && deal.getDiscountValue === 100);
        bar.classList.toggle('haima-bundle__bogo', isBogo);
        bar.classList.toggle('haima-bundle__gift-offer', isFreeGiftOffer);
        if (isBogo && !bar.querySelector('.haima-bundle__badge')) {
          const badge = document.createElement('span');
          badge.className = 'haima-bundle__badge';
          badge.textContent = 'Best-seller';
          bar.append(badge);
        }

        bar.querySelectorAll('.kaching-bundles__bar-variant').forEach((row, index) => {
          const gift = row.closest('[data-free-gift-id]');
          const giftSettings = gift && deal.freeGifts?.find((item) => item.id === gift.dataset.freeGiftId);
          const giftProductId = giftSettings?.productGID?.split('/').pop();
          const rowProduct = giftProductId ? readJSON(`.kaching-bundles-product[data-product-id="${giftProductId}"]`) : product;
          if (!rowProduct) return;
          const selects = row.querySelector('.kaching-bundles__bar-variant-selects');
          if (!selects) return;
          const controls = [...selects.querySelectorAll('select, [role="combobox"]')];
          controls.forEach((control, optionIndex) => {
            const option = rowProduct.options[optionIndex];
            if (!option) return;
            const field = control.closest('.kaching-bundles-option') || control;
            field.style.gridColumn = String(optionIndex + 1);
            field.style.gridRow = '2';
            let label = selects.querySelector(`[data-haima-option="${optionIndex}"]`);
            if (!label) {
              label = document.createElement('span');
              label.className = 'haima-bundle__option-label';
              label.dataset.haimaOption = optionIndex;
              label.style.gridColumn = String(optionIndex + 1);
              label.style.gridRow = '1';
              selects.append(label);
            }
            setText(label, `${option.name} :`);
            control.setAttribute('aria-label', `${option.name}, bracelet ${index + 1}`);
          });

          if (!isBogo) return;
          const values = controls.map((control) => control.tagName === 'SELECT' ? control.value :
            control.closest('[data-value]')?.dataset.value);
          const variant = rowProduct.variants.find((item) => item.options.every((value, i) => value === values[i]));
          const content = row.querySelector('.kaching-bundles__bar-variant__content');
          if (!variant || !content) return;
          let image = content.querySelector('.haima-bundle__image');
          if (!image) {
            image = document.createElement('img');
            image.className = 'haima-bundle__image';
            image.width = 120;
            image.height = 120;
            image.loading = 'lazy';
            content.prepend(image);
          }
          const source = variant.image || rowProduct.image;
          if (image.getAttribute('src') !== source) image.setAttribute('src', source);
          image.alt = `${rowProduct.title} — ${variant.options.join(' / ')}`;

          let pricing = content.querySelector('.haima-bundle__item-price');
          if (!pricing) {
            pricing = document.createElement('div');
            pricing.className = 'haima-bundle__item-price';
            pricing.append(document.createElement('strong'), document.createElement('s'));
            content.append(pricing);
          }
          const free = index === 1;
          pricing.classList.toggle('haima-bundle__item-price--free', free);
          const total = bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
          setText(pricing.firstElementChild, free ? 'FREE' : total || money(variant.price));
          setText(pricing.lastElementChild, money(variant.compareAtPrice || variant.price));
          pricing.lastElementChild.hidden = !free && !(variant.compareAtPrice > variant.price);
        });
      });
    });
  }

  // Kaching mounts asynchronously and rerenders rows after each variant change.
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      observer.disconnect();
      refresh();
      observe();
    });
  });
  function observe() {
    const section = document.querySelector('[data-haima-bundle-product-id]') || document.body;
    observer.observe(section, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['data-value', 'class'] });
  }
  document.addEventListener('change', (event) => {
    if (event.target.closest('.haima-bundle')) refresh();
  });
  document.addEventListener('shopify:section:load', () => {
    observer.disconnect();
    refresh();
    observe();
  });
  refresh();
  observe();
})();
